import { createApp } from "vue";
import App from "@/App.vue";
// import "@/registerServiceWorker";
import router from "@/router";
import store from "@/store";
import extensions from "@/extensions";
import payments from "@/payments";

payments();
extensions.init();
const app = createApp(App);
app
  .use(store)
  .use(router)
  .mount("#app");
